import { collection, addDoc, Timestamp } from 'firebase/firestore';
import React, { useState } from 'react';
import PrimaryButton from '../../components/buttons/PrimaryButton';
import Input from '../../components/inputs/Input';
import { db } from '../../firebase';
import SelectInput from '../../components/inputs/SelectInput';

function AddItem({ onClose, collectionPath, fields, title }) {
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [formValues, setFormValues] = useState(
    fields.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {})
  );
  const [errors, setErrors] = useState(
    fields.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {})
  );

  const resetState = () => {
    setError("");
    setFormValues(fields.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {}));
  };

  const handleChange = (fieldName) => (event) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [fieldName]: event.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoader(true);
      const collectionRef = collection(db, collectionPath);
      await addDoc(collectionRef, {
        ...formValues,
        active: true,
        dateCreation: Timestamp.now(),
      })
        .catch((err) => {
          console.error(err);
          setError("Une erreur est survenue, impossible d'ajouter l'élément.");
          setLoader(false);
          return;
        });

      setLoader(false);
      resetState();
      onClose();
    } catch (err) {
      console.error(err);
      setError("Une erreur est survenue, impossible d'ajouter l'élément.");
      setLoader(false);
    }
  };

  return (
    <div
      id="authentication-modal"
      tabIndex="-1"
      aria-hidden="true"
      className="mx-auto w-full fixed inset-0 flex items-center justify-center overflow-auto"
    >
      <div className="relative w-full max-w-md max-h-full">
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <button
            type="button"
            onClick={onClose}
            className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
          <div className="px-6 py-6 lg:px-8">
            <h3 className="mb-4 text-xl font-medium text-gray-900 dark:text-white">
              {title}
            </h3>

            <form onSubmit={handleSubmit}>
              {fields.map((field) => (
                <div key={field.name} className="mb-6">
                  {field.type === "select" ? (
                    <SelectInput 
                      id={field.name}
                      label={field.label}
                      defaultOption={field.defaultOption}
                      values={field.values}
                      onChange={handleChange(field.name)}
                    />
                  ) : (
                    <Input
                      id={field.name}
                      label={field.label}
                      type={field.type}
                      name={field.name}
                      value={formValues[field.name]}
                      onChange={handleChange(field.name)}
                      error={errors[field.name]}
                    />
                  )}
                </div>
              ))}

              <div className="text-center">
                <PrimaryButton type="submit" value="Ajouter" loading={loader} />
              </div>

              {error && <p className="justify-center flex my-1 text-red-500">{error}</p>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddItem;